import React from 'react';
import NotFoundPage from './404page';
import llama_magnify_clay from '../../assets/images/bumpclay/llama-magnify-clay.png';

const NotFoundStudioUpload = () => (
  <NotFoundPage
    heading1="Lost?"
    heading2="This video isn't available. Sorry about that."
    paragraph="Head back to Creator Studio to upload a new one."
    image={llama_magnify_clay}
    buttonText="Go to Creator Studio"
    buttonLink="/bumper"
  />
);

export default NotFoundStudioUpload;
